export const isVehiclesRequired = ({ anyParkedVehicles, isVehiclesValid }) =>
  anyParkedVehicles === 'yes' && !isVehiclesValid;
export const isPetsRequired = ({ anyPetsLiving, isPetsValid }) =>
  anyPetsLiving === 'yes' && !isPetsValid;
export const isEmergencyContactsRequired = ({
  anyEmergencyContacts,
  isEmergencyContactsValid,
}) => anyEmergencyContacts === 'yes' && !isEmergencyContactsValid;
